module.exports = __webpack_public_path__ + "static/media/package_support_10.6253cbb4.svg";